// extracted by mini-css-extract-plugin
export default {"changed":"SingleXMLItem_changed__diFN8"};